import { render } from "./AvatarsSlider.vue?vue&type=template&id=33b8b3ac"
import script from "./AvatarsSlider.vue?vue&type=script&lang=js"
export * from "./AvatarsSlider.vue?vue&type=script&lang=js"

import exportComponent from "/Users/emmanueledurante/Documents/Lavoro/Martech/whappy-app-front-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__